import PercentCompleteFormatter from '../components/Percentaje';
import StatusFormatter from '../components/Status';
import NormalStringFormatter from '../components/NormalStringFormatter';
const { Filters: { MultiSelectFilter, SingleSelectFilter } } = require('react-data-grid-addons');

export const DefaultHeaders = () => {
  return { headers:
      [
        {
          key: 'job_id',
          name: 'ID',
          formatter: NormalStringFormatter,
          sortable: true,
          filterable: true,
          filterRenderer: MultiSelectFilter
        },
        {
          key: 'job_type',
          name: 'Type',
          width: 120,
          formatter: NormalStringFormatter,
          sortable: true,
          filterable: true,
          filterRenderer: SingleSelectFilter
        },
        {
          key: 'account_name',
          name: 'Client',
          formatter: NormalStringFormatter,
          sortable: true,
          filterable: true,
          filterRenderer: MultiSelectFilter
        },
        {
          key: 'account_id',
          name: 'Account Id',
          formatter: NormalStringFormatter,
          sortable: true,
          filterable: true,
          filterRenderer: MultiSelectFilter
        },
        {
          key: 'media_id',
          name: 'Media Id',
          formatter: NormalStringFormatter,
          sortable: true,
          filterable: true,
          filterRenderer: MultiSelectFilter
        },
        {
          key: 'start_time',
          name: 'Started',
          formatter: NormalStringFormatter,
          sortable: true,
          filterable: true,
          filterRenderer: MultiSelectFilter
        },
        // {
        //   key: 'end_time',
        //   name: 'End At',
        //   formatter: NormalStringFormatter,
        //   sortable: true
        // },
        {
          key: 'total_time',
          name: 'Job Time',
          formatter: NormalStringFormatter,
          sortable: true
        },
        {
          key: 'clip_duration',
          name: 'Media Details',
          formatter: NormalStringFormatter,
          sortable: true
        },
        {
          key: 'zone',
          name: 'Zone',
          width: 50,
          formatter: NormalStringFormatter,
          sortable: true,
          filterable: true,
          filterRenderer: MultiSelectFilter
        },
        {
          key: 'status',
          name: 'Status',
          formatter: StatusFormatter,
          sortable: true,
          filterable: true,
          filterRenderer: MultiSelectFilter
        },
        // {
        //   key: 'workflow',
        //   name: 'Workflow',
        //   formatter: NormalStringFormatter,
        // },
        {
          key: 'progress',
          name: 'Progress',
          formatter: PercentCompleteFormatter,
          sortable: true
        }
      ]
    }
}


// WEBPACK FOOTER //
// ./src/conf/headers.js